import { useEffect, useState } from "react";
import { Badge, Dropdown, Button } from "react-bootstrap";
import { FaShoppingCart } from "react-icons/fa";
import { IoCartOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const CartIcon = ({ cart }) => {
    const navigate = useNavigate(); // Initialize navigate

    const [showDropdown, setShowDropdown] = useState(false);

    const [menuAlign, setMenuAlign] = useState("center");

    // Calculate total cart items
    const totalCartItems = Array.isArray(cart)
        ? cart.length
        : Object.values(cart || {}).reduce((sum, item) => sum + (item.qty || 0), 0);

    useEffect(() => {
        const updateAlignment = () => {
            if (window.innerWidth >= 768) {
                setMenuAlign("end"); // `md` and above → Align to end
            } else {
                setMenuAlign("center"); // `xs` (small screens) → Align center
            }
        };

        updateAlignment(); // Set initial value
        window.addEventListener("resize", updateAlignment);

        return () => window.removeEventListener("resize", updateAlignment);
    }, []);

    return (
        <Dropdown
            show={showDropdown}
            style={{ background: 'transparent' }
            } onToggle={(isOpen) => setShowDropdown(isOpen)}>
            <Dropdown.Toggle style={{ background: 'transparent' }} className="p-0 border-0 bg-transparent position-relative">
                {/* Badge for item count */}
                <Badge
                    bg="info"
                    pill
                    className="position-absolute top-0 end-90 translate-middle"
                    style={{
                        fontSize: "0.7rem",
                        margin: "1px 12px 5px 1px",
                        padding: "5px 7px",
                        color: 'green'
                    }}
                >
                    {totalCartItems}
                </Badge>
                {/* Cart Icon */}
                <IoCartOutline color="green" size={24} />
            </Dropdown.Toggle>

            {/* Dropdown for cart items */}
            <Dropdown.Menu
                align={menuAlign}
                style={{ minWidth: "250px", background: 'white' }}>
                <Dropdown.Header>Keranjang</Dropdown.Header>
                {totalCartItems === 0 ? (
                    <Dropdown.Item disabled>No items in cart</Dropdown.Item>
                ) : (
                    <>
                        {cart.map((item, index) => (
                            <Dropdown.Item key={index} className="d-flex align-items-center">
                                <img
                                    src={item.product.image || "default_480x320.png"}
                                    alt={item.product.name}
                                    width={40}
                                    height={40}
                                    className="me-2 rounded"
                                />
                                <div>
                                    <small>{item.product.name}</small>
                                    <p className="m-0">
                                        Rp. {item.product.starting_price} x {item.qty}
                                    </p>
                                </div>
                            </Dropdown.Item>
                        ))}
                        <Dropdown.Divider />
                        <Dropdown.Item as="div" className="text-center">
                            <Button
                                style={{
                                    background: '#d9534f',
                                    border: '2px solid #b52b27', // Border color
                                    color: 'white',
                                    padding: '10px 20px',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => e.target.style.background = '#c9302c'} // Hover effect
                                onMouseLeave={(e) => e.target.style.background = '#d9534f'}
                                size="sm"
                                className="w-100"
                                onClick={() => navigate("/cart")} // Navigate to cart
                            >
                                Lihat Keranjang
                            </Button>
                        </Dropdown.Item>
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default CartIcon;